module.exports = __webpack_public_path__ + "img/infinity-war.3298868.png";